export default __webpack_public_path__ + "static/media/Evento_3.6f56d58b.jpg";